import authRequest from '../authRequest';
import NoteTemplatePresenter from '../../presenters/NoteTemplatePresenter';

const updateNoteTemplate = async (uuid, name, content) => {
  try {
    // Validate required parameters
    if (!uuid) {
      throw new Error('Template UUID is required');
    }
    if (!name) {
      throw new Error('Template name is required');
    }
    if (!content) {
      throw new Error('Template content is required');
    }

    const response = await authRequest(`/note_templates/${uuid}`, {
      method: 'PUT',
      data: {
        note_template: {
          name: name,
          content: content
        }
      }
    });

    if (response.status === 200) {
      return new NoteTemplatePresenter(response.data);
    } else {
      throw new Error('Failed to update note template');
    }

  } catch (error) {
    console.error('Error updating note template:', error);
    throw error;
  }
};

export default updateNoteTemplate;
